module.exports = __webpack_public_path__ + "static/media/1.9a10c202.jpg";